export const breakingNewsItems = [
  {
    id: 1,
    title: 'Supreme Court strikes down electoral bond scheme as unconstitutional',
    url: '/article/supreme-court-electoral-bonds-unconstitutional',
  },
  {
    id: 2,
    title: 'Delhi High Court stays online streaming of film pending resolution of copyright dispute',
    url: '/article/delhi-high-court-stays-film-copyright',
  },
  {
    id: 3,
    title: 'Supreme Court grants interim bail to activist in UAPA case',
    url: '/article/supreme-court-bail-uapa-case',
  },
  {
    id: 4,
    title: 'Calcutta High Court sets aside state government order on property tax',
    url: '/article/calcutta-high-court-property-tax',
  },
];